import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	gap: var(--gap);
	padding-bottom: var(--spacing-large);
`;
